import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "@env/environment";

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

	constructor() {
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		let newHeaders = new HttpHeaders();
		newHeaders = newHeaders.append('Accept', 'application/json');
		// newHeaders = newHeaders.append('Channel', environment.channel);
		// newHeaders = newHeaders.append('Content-Type', 'application/json; charset=utf-8');
		if (request.headers.get('X-Skip-Headers')) {
			request = request.clone({headers: request.headers.delete('x-skip-headers')});
			return next.handle(request);
		}
		// newHeaders = newHeaders.append('Access-Control-Allow-Origin', '*');
		newHeaders = newHeaders.append('Institution-Id', environment.institutionCode);

		const hasContentType: boolean = request.headers.has('Content-Type');
		if (!hasContentType) {
			newHeaders = newHeaders.append('Content-Type', 'application/json; charset=utf-8');
		}
		let basicAuthRequest = request.clone({headers: newHeaders});
		const hasSkipOAuth: boolean = request.headers.has(environment.auth.interceptorSkipHeader);

		if (hasSkipOAuth) {
			basicAuthRequest = request.clone({headers: newHeaders});
			return next.handle(basicAuthRequest.clone({
				headers: basicAuthRequest.headers.set('Authorization', environment.auth.basic)
			}));
		}
		return next.handle(request);
	}
}
